module.exports = __webpack_public_path__ + "img/the-british-journal-for-the-philosophy-of-science-cover.e92a208b.jpg";